import ApplicationAdapter from 'eflex/adapters/application';

export default class AdamIoAdapter extends ApplicationAdapter {
  pathForType() {
    return 'hardwares';
  }
}
